module.exports = __webpack_public_path__ + "static/media/ALZ-ACETATO.6c0f69fd.jpg";